export default __webpack_public_path__ + "static/2-0_HSR_Icon-3e83301509486e6afe44c961ef3b9226.png";